export const url = "https://api.novitaschem.com/api";
export const baseUrl = "https://api.novitaschem.com";
// export type { Product, Highlight, Application, SearchResults, Result };
